import i18next from 'i18next';

export const getAlertTypeTranslation = (alertType: string): string => {
  const alertTypeKey = `alerts:alertTypes.${alertType}.title`;
  return i18next.exists(alertTypeKey) ? i18next.t(alertTypeKey) : alertType;
};
